import React, { useEffect } from "react";
import { CONNECT4_RULES } from "./connect4Rules";
import "./rules.css";

function RulesModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="c4-rules-overlay" onClick={onClose} role="presentation">
      <div
        className="c4-rules-card c4-rules-card--modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="c4-rules-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="c4-rules-close"
          onClick={onClose}
          aria-label="Close rules"
        >
          ×
        </button>
        <h2 id="c4-rules-modal-title" className="c4-rules-title">
          How to Play
        </h2>
        <ol className="c4-rules-list">
          {CONNECT4_RULES.map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ol>
      </div>
    </div>
  );
}

export default RulesModal;
